(ns teamoesterreich.user-mode.map.map-picker
  (:require [goog.json :as json]
            [reagent.core :as r]
            [teamoesterreich.firebase.remote-config :as remote-config]
            [teamoesterreich.util.log :as log]))

(defn get-mainMarker []
  (js/google.maps.Marker.
    (clj->js {:title "Suche"
              :color "blue"})))



(defn gmap-component [!st]
  (log/out "Mount gmap-picker ")
  (let [
        json-options (remote-config/get-string "location_map_center")
        {lat "lat" lng "lng" zoom "zoom"} (js->clj (json/parse (if (= json-options "") "{\"lat\": 48.17, \"lng\": 11.6, \"zoom\": 7.4}" json-options)))
        gmap (atom nil)

        options (clj->js {"center" (js/google.maps.LatLng. lat lng)
                          "zoom"   zoom})
        update (fn [parm]
                 ;;(log/out "Update Gmap called (sel)" @!st)
                 (if (:map-x @!st)
                   (do
                     ;(.setCenter (:map @gmap) (js/google.maps.LatLng. (:map-x @!st) (:map-y @!st)))
                     (.setMap ^js (:mainMarker @gmap) (:map @gmap))
                     (.setPosition (:mainMarker @gmap) (js/google.maps.LatLng. (:map-x @!st) (:map-y @!st))))
                   (when (:mainMarker @gmap) (.setMap ^js (:mainMarker @gmap) nil)))
                 (.setOptions ^js (:map @gmap) (clj->js {"draggableCursor" (if (and @!st (:pickMode @!st)) "crosshair" "pointer")}))
                 )]
    (add-watch !st :on-change (fn [] (log/out "Watch !st" @!st) (update {})))
    (r/create-class
      {:reagent-render       (fn [] [:div#map-canvas
                                     {:style {:border (if (and @!st (:pickMode @!st)) "2px solid red" "2px solid white")
                                              }}])
       :component-did-mount  (fn [comp]
                               (let [canvas (.getElementById js/document "map-canvas")
                                     gm (js/google.maps.Map. canvas options)]
                                 (reset! gmap {:map gm :mainMarker (get-mainMarker)}))
                               (update comp)
                               (js/google.maps.event.addListener (:map @gmap) "click"
                                                                 (fn [e]
                                                                   (let [clicked-location (.-latLng ^js e)
                                                                         query #js {:fields   ["formatted_address"]
                                                                                    :radius   "500"
                                                                                    :location clicked-location}]
                                                                     (when (:pickMode @!st)
                                                                       (log/out "map clicked " (.lat clicked-location) (.lng clicked-location) clicked-location)
                                                                       (swap! !st assoc :map-x (.lat clicked-location) :map-y (.lng clicked-location) :pickMode false)

                                                                       (.nearbySearch (js/google.maps.places.PlacesService. (:map @gmap))
                                                                                      query
                                                                                      (fn [res status] (log/out "map click search address result ##" query " =" status " -> " res))
                                                                                      )


                                                                       (update comp))
                                                                     )))

                               )
       :component-did-update (fn [params]
                               (update params)

                               )

       :display-name         "gmap-component"})))


(def pick-place
  gmap-component)